import React from "react";
import { Link } from "react-router-dom";

const MiniSection = () => {
  return (
    // Section Container: Relative positioning for layers
    <section className="relative py-24 bg-blue-900 overflow-hidden">
      {/* --- Background Layer: Image + Overlay --- */}
      <div className="absolute inset-0">
        {/* Background Image with Opacity for texture */}
        <img
          src="https://images.unsplash.com/photo-1451187580459-43490279c0fa?ixlib=rb-1.2.1&auto=format&fit=crop&w=1952&q=80"
          alt="Innovation Background"
          className="w-full h-full object-cover opacity-30 mix-blend-overlay"
        />

        {/* Blue Gradient Overlay to ensure text readability */}
        <div className="absolute inset-0 bg-gradient-to-r from-blue-900 via-blue-900/80 to-indigo-900/80"></div>
      </div>

      {/* --- Content Layer --- */}
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="text-center max-w-4xl mx-auto">
          {/* Badge */}
          <span className="inline-block py-1 px-3 rounded-full bg-white/10 text-blue-200 text-sm font-semibold tracking-wide uppercase mb-6 border border-white/20 backdrop-blur-sm">
            Join the Future
          </span>

          {/* Main Title */}
          <h1 className="text-5xl sm:text-6xl md:text-7xl font-extrabold text-white tracking-tight mb-6 leading-tight">
            YARQIN TECH HUB
          </h1>

          {/* Divider */}
          <div className="w-24 h-1 bg-blue-400 mx-auto mb-8 rounded-full"></div>

          {/* Subtitle */}
          <h2 className="text-xl sm:text-2xl md:text-3xl font-medium text-blue-100 mb-10 leading-relaxed">
            {/* A Bridge Between Innovation, Trust, <br />
            and Business Growth. */}
            PROFESSIONAL KNOWLEDGE FOR A DIGITAL FURUTE
          </h2>

          {/* Action Button */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/contact"
              className="inline-flex items-center px-8 py-4 bg-white text-blue-700 font-bold rounded-full shadow-xl hover:bg-blue-50 transition-all duration-300 transform hover:-translate-y-1"
            >
              Start Your Journey
              <svg
                className="w-5 h-5 ml-2"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M17 8l4 4m0 0l-4 4m4-4H3"
                ></path>
              </svg>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MiniSection;
